<template>
  <label class="d-block">
    <span :class="labelClass">{{ label }}</span>
    <v-text-field class="ag-text-field" v-bind="computedProps" v-on="$listeners"> </v-text-field>
  </label>
</template>

<script>
import { VTextField } from "vuetify/lib";

export default {
  name: "AgTextField",
  extends: VTextField,

  computed: {
    computedProps() {
      const props = { ...this.$props };
      delete props.label;
      return {
        ...props,
      };
    },
    labelClass() {
      return {
        label: true,
        "label--error": this.hasError && this.hasState,
      };
    },
  },
};
</script>

<style lang="scss">
.ag-text-field.error--text,
.ag-text-field.error--text .v-messages__message {
  color: #d43d3d !important;
  caret-color: #d43d3d !important;
}

.ag-text-field.error--text.v-text-field--outlined {
  & > .v-input__control > .v-input__slot {
    // background-color: #ffe9e9;
  }
}
.label {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #777c87;

  &--error {
    color: #bd2c2c;
  }
}
</style>
